import { TriangleAlert } from 'lucide-react';

import { type RawToolDescriptionMode } from '@apps/web/components/phoebe_chat/agent_test_mode';

export function RawModeBanner({
    toolDescriptions,
}: {
    readonly toolDescriptions: RawToolDescriptionMode;
}) {
    return (
        <div
            role="status"
            aria-label="Raw agent warning"
            className="flex shrink-0 items-center gap-2 border-b border-amber-500 bg-amber-100 px-3 py-1.5 text-xs font-semibold text-amber-950 dark:bg-amber-950 dark:text-amber-100"
        >
            <TriangleAlert aria-hidden={true} className="size-4 shrink-0" />
            <span className="tracking-wide uppercase">Raw mode</span>
            <span className="font-normal">
                No Phoebe system prompt or skill guidance ·{' '}
                {toolDescriptions === 'full'
                    ? 'Full tool descriptions'
                    : 'Stripped tool descriptions'}
            </span>
        </div>
    );
}
